export default __webpack_public_path__ + "static/media/khaf-screens.2fd59465.png";